<template>
  <div class="row m-0 qpBox">
    <div class="col-md-12 py-5 m-auto qpMsg">
      <p>Following my appointment in 2022 and election in 2024, I have followed through on Governor Scott’s assessment of my qualifications and confidence to serve my represented districts well, encouraging every town in the Essex-Caledonia District to take advantage of State sponsored opportunities to strengthen their communities. Eight of the ten towns in the District were successful with receiving grant awards through the Municipal Energy Resilience Program (MERP) to upgrade town facilities regarding weatherization, thermal efficiency, building renovation, and replacement of fossil fuel heating systems to more efficient renewable systems. As preparation for the 2026 Legislative session is underway, I look forward to supporting each town for their efforts to seek out opportunities to enhance their communities.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExtraInfo"
}
</script>

<style scoped>
a {
  font-weight: bold;
  color: rgb(79, 121, 168);
}
.quoteText{
  font-size: 24px;
  font-style: italic;
}
.qpBox{
  background-color: rgb(245,245,245);
}

.qpMsg{
  width: 95%;
}
</style>
